import React from 'react';
import { BulletPoint } from '../../types/types';
import { Accordion } from './Accordion';

type Props = {
  points: BulletPoint[];
};

export const ControlledAccordion: React.FC<Props> = props => {
  const [expanded, setExpanded] = React.useState<number | false>(false);
  const points = props.points;

  const handleChange = (item: number) => (_event: React.ChangeEvent<{}>, isExpanded: boolean) => {
    setExpanded(isExpanded ? item : false);
  };

  if (!(points && points.length)) {
    return null;
  }

  return (
    <>
      {props.points.map((point, index) => {
        return <Accordion key={index} index={index} expanded={expanded === index} point={point} onChange={handleChange(index)} />;
      })}
    </>
  );
};
